module.exports = __webpack_public_path__ + "static/media/3-Hearts.039d4567.svg";